import { NormalStatus } from '@/constants/normal-status'

export type OptionWithStatus<V> = { value: V, status: NormalStatus };

export default function filterOptionsWithStatus<V>(options: OptionWithStatus<V>[] = [], values: V[] = []) {
  return options.filter(option => {
    if (values.includes(option.value)) {
      return true
    }
    return option.status !== NormalStatus.Deactivated
  })
}
